"use client";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router";
import EventDetailBanner from "./views/EventDetailBanner";
import EventDetailHead from "./views/EventDetailHead";
import EventDetailBody from "./views/EventDetailBody";
import RegisterNew from "../NewEvent/views/RegisterNew";
import MetaTags from "react-meta-tags";
import ButtonDKN from "../Button/ButtonDKN";
import { Spinner } from "flowbite-react";

const fetchDataCategory = async () => {
  const response = await axios.get(
    "https://api-bluerise.bluerise.com.vn/category/get-all"
  );
  if (response.status === 200) {
    return response.data;
  }
  return null;
};

const fetchDataNews = async (slug) => {
  const response = await axios.post(
    "https://api-bluerise.bluerise.com.vn/news/get-by-slug",
    {
      keyword: slug,
    }
  );
  if (response.status === 200) {
    return response.data;
  }
  return null;
};

//

//

const fetchDataRelatedNews = async (slug) => {
  const response = await axios.post(
    "https://api-bluerise.bluerise.com.vn/news/get-related",
    {
      keyword: slug,
    }
  );
  if (response.status === 200) {
    return response.data;
  }
  return null;
};

function extractFirstImageAndText(htmlContent) {
  // Tìm thẻ <img> đầu tiên
  const imgRegex = /<img[^>]*src="([^"]*)"[^>]*>/;
  const match = imgRegex.exec(htmlContent);

  let firstImage = null;
  if (match) {
    firstImage = match[1]; // Lấy src của thẻ <img> đầu tiên
  }

  // Xóa thẻ <img> đầu tiên khỏi nội dung HTML
  const textWithoutFirstImage = htmlContent.replace(imgRegex, "");

  return { text: textWithoutFirstImage, firstImage };
}

export default function EventDetail() {
  const { slug } = useParams();
  const [categories, setCategories] = useState(null);
  const [article, setArticle] = useState();
  const [relatedArticles, setRelatedArticles] = useState([]);
  const [mainContent, setMainContent] = useState("");
  const [imgBanner, setImgBanner] = useState("");
  const [shortContent, setShortContent] = useState("");

  useEffect(() => {
    if (article && article.id > 0) {
      let shortContent = extractFirstImageAndText(article.shortContent ?? "");
      setShortContent(shortContent.text);
      let content = extractFirstImageAndText(article.mainContent ?? "");
      setImgBanner(content.firstImage);
      setMainContent(content.text);
    }
  }, [article]);

  useEffect(() => {
    if (slug) {
      fetchDataCategory().then((data) => {
        setCategories(data);
      });
      fetchDataNews(slug).then((data) => {
        setArticle(data);
      });
      fetchDataRelatedNews(slug).then((data) => {
        setRelatedArticles(data);
      });
    }
  }, [slug]);

  return (
    <div className="pt-[71px] w-full">
      {(!article || !article.id) && (
        <div className="mt-4 flex items-center justify-center">
          <Spinner aria-label="Default status example" />
        </div>
      )}
      {categories && categories.length > 0 && article && article.id > 0 && (
        <>
          <MetaTags>
            {article.title && <title>Blue Rise - {article.title}</title>}
            {article.description && (
              <meta name="description" content={article.description} />
            )}
            {article.title && (
              <meta property="og:title" content={article.title} />
            )}
            {imgBanner && <meta property="og:image" content={imgBanner} />}
          </MetaTags>
          <EventDetailBanner
            title={article.title}
            shortContent={shortContent}
          />
          <EventDetailHead
            article={{ ...article, mainContent: mainContent }}
            imgBanner={imgBanner}
            categories={categories}
          />
          <EventDetailBody
            relatedNews={relatedArticles}
            categories={categories}
          />
          <RegisterNew />
          {article.showRegisterForm && (
            <div className="fixed bottom-0 z-50 flex items-center  justify-center w-full">
              <div className="w-full md:w-[30%]">
                <ButtonDKN
                  txt="ĐĂNG KÝ NGAY"
                  cl="hover:bg-blue-700 bg-[#fdb62f] text-2xl font-semibold animate-bounce  hover:text-white md:h-[60px] transform transition-transform duration-300 ease-in-out hover:scale-110"
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
